import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonToolbar } from "@ionic/react";
import { ProductDescription } from "../../types/types";
import { closeOutline } from "ionicons/icons";
import AppHeader from "../../components/AppHeader/AppHeader";
import { useTranslation } from "react-i18next";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import remarkGfm from 'remark-gfm'
import React, { PropsWithChildren } from "react";

interface InfoComponentProps extends PropsWithChildren {
    info: ProductDescription[],
    closeAction:Function
}

const GiftCardInfoComponentPage: React.FC<InfoComponentProps> = ({ info,closeAction}) => {

    const { t, i18n } = useTranslation();
    const nav = document.querySelector("ion-nav");

    return (
        <IonPage>
            <IonHeader className="ion-no-border">

                <IonToolbar>

                    <IonButtons slot="start">
                        <IonButton 
                            color={'primary'}
                            onClick={() => { closeAction() }}>
                            <IonIcon slot="icon-only" icon={closeOutline} />
                        </IonButton>

                    </IonButtons>
                </IonToolbar>

                <AppHeader
                    title={t('giftcard.products.page.DESCRIPTION-HEADER') as string}
                    goBack={false}
                >

                </AppHeader>

            </IonHeader>
            <IonContent className="ion-padding">
                <ReactMarkdown className="reactMarkdown"
                    children={info[0].read_more_markdown}
                    remarkPlugins={[remarkGfm]}
                />
            </IonContent>
        </IonPage>

    )
}

export default React.memo(GiftCardInfoComponentPage)